import React from 'react';
import { View } from 'react-native';

import { LinearGradientProps } from './types';

export const LinearGradient = (props: LinearGradientProps) => {
    const getAngle = () => {
        if (props.angle) {
            return props?.angle + 'deg';
        }

        const startX = props.start?.x ?? 0.5;
        const startY = props.start?.y ?? 0.5;
        const endX = props.end?.x ?? 0.5;
        const endY = props.end?.y ?? 0.5;

        const dx = endX - startX;
        const dy = endY - startY;

        // Convert to CSS linear-gradient angle (0deg = top, 90deg = right)
        // Math.atan2 gives us the angle from positive x-axis, but CSS needs from top
        const angle = Math.atan2(dx, -dy) * (180 / Math.PI);
        return angle + 'deg';
    };

    const getColors = () =>
        props.colors
            .map((color, index) => {
                const location = props.positions ? props.positions[index] : undefined;
                let locationStyle = '';
                if (location) {
                    locationStyle = ' ' + location * 100 + '%';
                }
                return color + locationStyle;
            })
            .join(',');

    return <View style={[props.style, { backgroundImage: `linear-gradient(${getAngle()},${getColors()})` }]} />;
};
